import type { ReactNode } from 'react';

type Props = {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
};

export default function PageHeader({ eyebrow, title, subtitle, actions }: Props) {
  return (
    <header className="flex items-end justify-between gap-6 pb-6 mb-8 border-b border-ink-100">
      <div>
        {eyebrow && (
          <div className="text-xs font-medium uppercase tracking-wider text-ink-500 mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="text-3xl font-semibold tracking-tight text-ink-900 leading-tight">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm text-ink-500 mt-1.5">{subtitle}</p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </header>
  );
}
